import { AnyAction } from 'redux';
import { DemandState } from '@synergy/models';

import {
    DEMAND_DETAIL_CLEARED,
    DEMAND_DETAIL_PATCH_STARTED,
    DEMAND_DETAIL_PATCH_SUCCESS,
    DEMAND_DETAIL_RECEIVED,
    DEMAND_DETAIL_REQUESTED,
} from './demands-detail-actions';
import { DemandDetail } from '../models/demand-detail';

export interface DemandsDetailReducerState {
    demand?: DemandDetail;
    readonly: boolean;
    requesting: boolean;
}

const initialDemandsDetailReducerState: DemandsDetailReducerState = {
    requesting: false,
    readonly: false,
};

export const demandsDetailReducer = (
    state: DemandsDetailReducerState = initialDemandsDetailReducerState,
    action: AnyAction
): DemandsDetailReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case DEMAND_DETAIL_PATCH_SUCCESS: {
            return {
                ...state,
                requesting: false,
            };
        }

        case DEMAND_DETAIL_PATCH_STARTED: {
            return {
                ...state,
                requesting: true,
            };
        }

        case DEMAND_DETAIL_REQUESTED: {
            return {
                ...state,
                demand: undefined,
                requesting: true,
            };
        }

        case DEMAND_DETAIL_RECEIVED: {
            return {
                ...state,
                demand: rest['demand'],
                requesting: false,
                // Also once the survey has ended: the member's own state can
                // still read "reported", and the mask stood there as an empty
                // form to fill in (#2287).
                readonly:
                    rest['demand'].status === DemandState.ClosedNoDemand ||
                    rest['demand'].status === DemandState.ClosedWithDemand ||
                    (!!rest['demand'].endDate && new Date(rest['demand'].endDate) < new Date()),
            };
        }

        case DEMAND_DETAIL_CLEARED: {
            return initialDemandsDetailReducerState;
        }

        default: {
            return state;
        }
    }
};
